export const getOwnPhoneNumber = () => null;
